import { useRef, useState } from "react";
import { Button, Card, Toast } from "react-bootstrap";
import { IAgent } from "../../models/agent";
import { FaCode, FaCopy } from 'react-icons/fa';

type Props = {
    agent: IAgent;
}

function FloatingChatbot({agent}: Props) {
    const [showToast, setShowToast] = useState(false)
    const codeRef = useRef<HTMLPreElement>(null);

    const baseURL = process.env.REACT_APP_URL;
    const apiURL = process.env.REACT_APP_API_URL;

    const codeText = `<!-- Embed quickyChatbot -->
<script>
  // Required variables — Compatible with older browsers
  window.accessKey = "${agent.accessKey}";
  window.apiURL = "${apiURL}";
</script>
<script
  src="${baseURL}embed/script.js"
  accessKey = "${agent.accessKey}"
  apiURL = "${apiURL}"
  defer>
</script>`;

    const handleCopy = () => {
        if (codeRef.current) {
            navigator.clipboard.writeText(codeRef.current.innerText)
                .then(() => {
                    setShowToast(true);
                });
        }
    };

    return (
        <Card className="mb-4" style={{ backgroundColor: '#2d2d2d', borderColor: '#444' }}>
            <Card.Header style={{ backgroundColor: '#333', borderBottom: '1px solid #444', padding: '16px' }}>
                <div className="d-flex align-items-center">
                    <FaCode size={20} style={{ color: '#fff', marginRight: '12px' }} />
                    <h5 style={{ color: '#fff', margin: 0 }}>Floating Chatbot</h5>
                </div>
            </Card.Header>
            <Card.Body style={{ padding: '24px' }}>
                <p style={{ color: '#ccc', marginBottom: '20px' }}>
                    Copy and paste the script below to your website to show a floating chatbot widget.
                </p>
                
                <div style={{ position: 'relative' }}>
                    <pre 
                        ref={codeRef} 
                        style={{
                            backgroundColor: '#1a1a1a',
                            color: '#fff',
                            padding: '16px',
                            borderRadius: '8px',
                            border: '1px solid #555',
                            overflowX: 'auto',
                            fontSize: '14px',
                            lineHeight: '1.4',
                            marginBottom: '0'
                        }}
                    >
                        {codeText}
                    </pre>
                    <Button 
                        onClick={handleCopy}
                        style={{
                            position: 'absolute',
                            top: '12px',
                            right: '12px',
                            backgroundColor: '#007bff',
                            borderColor: '#007bff',
                            color: '#fff',
                            padding: '8px 12px',
                            fontSize: '14px',
                            display: 'flex',
                            alignItems: 'center',
                            gap: '6px'
                        }}
                    >
                        <FaCopy size={14} />
                        Copy
                    </Button>
                </div>

                {/* Toast for copy confirmation */}
                <Toast
                    onClose={() => setShowToast(false)}
                    show={showToast}
                    delay={2000}
                    autohide
                    style={{
                        position: 'fixed',
                        top: '20px',
                        right: '20px',
                        zIndex: 1000,
                        backgroundColor: '#2d2d2d',
                        borderColor: '#28a745'
                    }}
                >
                    <Toast.Body style={{ color: '#28a745' }}>
                        Code copied to clipboard!
                    </Toast.Body>
                </Toast>
            </Card.Body>
        </Card>
    );
}

export default FloatingChatbot